import { DisclosureSection } from '@components/core-ui/DisclosureSection';
import { AdminGetOrganizationResponseDto } from 'app/API';
import { useState } from 'react';
import { Wrapper } from './styles/Wrapper';
import { TeamCards } from '../TeamCards';

type TProps = {
  teams: AdminGetOrganizationResponseDto['Teams'];
};

export const TeamsList = ({ teams }: TProps) => {
  const [teamsDisclosureOpen, setTeamsDisclosureOpen] = useState<boolean>(true);

  const teamsTitle = `Teams${teams.length > 0 ? ` (${teams.length})` : ''}`;

  return (
    <Wrapper className="flex flex-col">
      <div>
        <DisclosureSection
          title={teamsTitle}
          open={teamsDisclosureOpen}
          setOpenState={setTeamsDisclosureOpen}
          loading={false}
        >
          <TeamCards teams={teams} />
        </DisclosureSection>
      </div>
    </Wrapper>
  );
};
